import React from 'react';

export const PlusSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={13}
      height={12}
      fill='none'
    >
      <path
        fill='#040325'
        d='M6.012 12a.779.779 0 0 1-.779-.779V6.694H.755a.755.755 0 1 1 0-1.51h4.478V.78a.779.779 0 1 1 1.558 0v4.406h4.479a.755.755 0 0 1 0 1.509H6.79v4.527c0 .43-.349.779-.779.779Z'
      />
    </svg>
  );
};
